// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createVerticalSmallHeadingAndTextStyles } from "@eisinc/App/SharedStyles/smallHeadingAndTextStyles";
import { cartLineNotesStyles } from "@eisinc/Overrides/Widgets/Cart/CartLineNotes";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

cartLineNotesStyles.toggleLink = {
    typographyProps: {
        ...fontConfig.singleLinexSmall,
        weight: fontConfig.weight.medium,
    },
    css: css`
        align-self: baseline;
    `,
};
cartLineNotesStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};
cartLineNotesStyles.label = {
    ...fontConfig.singleLinexSmall,
    css: css`
        &:empty {
            display: none;
        }
    `,
};
cartLineNotesStyles.readOnlyNotesText = {
    ...createVerticalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                margin-top: 4px;
            `,
        },
        heading: {
            ...fontConfig.singleLinexSmall,
        },
        text: {
            ...fontConfig.singleLinexSmall,
        },
    }),
};
